'use es6';

import styled from 'styled-components';
import HR from 'UIComponents/elements/HR';
import { BATTLESHIP } from 'HubStyleTokens/colors';
const Divider = styled(HR).withConfig({
  displayName: "Divider",
  componentId: "qagt12-0"
})(["width:100%;margin:14px 0;color:", ";border-color:", ";background-color:", ";"], BATTLESHIP, BATTLESHIP, BATTLESHIP);
export default Divider;